import React from "react";
import { Typography, Box } from "@mui/material";
import RadioButtonUnchecked from "@mui/icons-material/TripOrigin";
import Album from "@mui/icons-material/Album";

const TitleLabel = ({ label, isDetail = false }) => {

  const Icon = isDetail ? RadioButtonUnchecked : Album;

  return (
    <Box display="flex" alignItems="center" gap={1}>

      <Icon
        style={{ width: "10px", marginTop: "0px" }}
        fontSize="small"
        color="primary"
      />
      <Typography variant="subtitle1" fontWeight="bold">
        {label}
      </Typography>
    </Box>
  );
};

export default TitleLabel;
